module.exports = __webpack_public_path__ + "img/balkon10.a38b035c.webp";